import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-print-ticket-render',
  templateUrl: './print-ticket-render.component.html',
  styleUrls: ['./print-ticket-render.component.scss']
})
export class PrintTicketRenderComponent {

  params: any;
  getLabelFunction: any;

  agInit(params: any): void {
    this.params = params;
    this.getLabelFunction = this.params.getLabelFunction;
  }

  refresh(params?: any): boolean {
    return true;
  }
  
  isPopup(): boolean {
    return false;
  }

  onClick($event) {
    console.log('show details',$event);
    console.log('params: ',this.params);
    if (this.params.onClick instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node,
      };
      this.params.onClick(params);
    }
  }

}